import React from 'react';

function ChevronRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M6.3999 3.2002L11.3835 8.1838L6.3999 13.1674" stroke="#A8ACB8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
}

export default ChevronRight;